import { getAuth } from 'firebase/auth';
import API_CONFIG from '../config/api';
import { getApiUrl } from '../config/api';

export const createCheckoutSession = async (planId, isYearly, promoCode = null) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error('User must be logged in');
    }

    // Log the request details
    console.log('Creating checkout session:', {
      planId,
      billingCycle: isYearly ? 'yearly' : 'monthly',
      userId: user.uid,
      customerEmail: user.email,
    });

    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.STRIPE.CREATE), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        planId: isYearly ? 'premium-yearly' : 'premium-monthly', // Match database plan IDs
        userId: user.uid,
        customerEmail: user.email,
        billingCycle: isYearly ? 'yearly' : 'monthly',
        promoCode: promoCode || undefined
      })
    });

    // Log the raw response
    const responseText = await response.text();
    console.log('Raw server response:', responseText);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}, body: ${responseText}`);
    }

    // Parse the response
    const data = JSON.parse(responseText);
    
    if (!data.success) {
      throw new Error(data.error || 'Failed to create checkout session');
    }

    return {
      sessionId: data.sessionId,
      sessionUrl: data.sessionUrl
    };

  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw new Error('Failed to create checkout session: ' + error.message);
  }
};

export const handleSubscriptionStatus = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error('User must be logged in');
    }
console.log(`API_CONFIG.ENDPOINTS.STRIPE.CREATE: ${getApiUrl(API_CONFIG.ENDPOINTS.STRIPE.CREATE)}`);
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.STRIPE.CREATE),{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await user.getIdToken()}`,
      },
    });

    const data = await response.json();

    if (data.error) {
      throw new Error(data.error);
    }

    return data;
  } catch (error) {
    console.error('Subscription status error:', error);
    throw error;
  }
};

export const verifySubscriptionSession = async (sessionId) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser; // Get current user directly

    if (!user) {
      throw new Error('No authenticated user found');
    }

    if (!sessionId) {
      throw new Error('Session ID is required');
    }

    console.log('Verifying session:', { sessionId, userId: user.uid }); // Debug log

    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.STRIPE.VERIFY_SESSION), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sessionId: sessionId,
        userId: user.uid
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Server response:', errorText); // Debug log
      throw new Error(`Verification failed: ${errorText}`);
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Verification failed');
    }

    return data;
  } catch (error) {
    console.error('Subscription verification error:', error);
    throw new Error('Failed to verify subscription: ' + error.message);
  }
};

export const getSubscriptionPortalUrl = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error('User must be logged in');
    }

    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.STRIPE.CUSTOMER_PORTAL), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await user.getIdToken()}`
      }
    });

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Failed to get portal URL');
    }

    return data.url;
  } catch (error) {
    console.error('Customer portal error:', error);
    throw error;
  }
};